import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[grid-header-filter-dropdown-template]',
  standalone: false,
})
export class GridHeaderFilterDropdownTemplateDirective {
  constructor(public template: TemplateRef<any>) {}
}
